@if (galleryPermissions().can_edit || textTitle || textParagraph) {
  <div [class.dark]="darkBackground()" [class.editable]="galleryPermissions().can_edit">
    <div class="text-section">
      @if (galleryPermissions().can_edit || textTitle) {
        <div
          class="input-container title {{ titleFontSize() }} {{
            section().text_title_typography.text_alignment || theme().section.title_typography.text_alignment
          }}"
          [appApplyTypographyStyles]="[
            section().text_title_typography,
            theme().section.title_typography,
            tenant()?.default_title_typography,
          ]"
        >
          <div
            class="input"
            [attr.contenteditable]="galleryPermissions().can_edit"
            [(wysiwyg)]="textTitle"
            [defaultFontFamily]="
              theme().section.title_typography.font_family || tenant()?.default_title_typography?.font_family
            "
            [allowFontChanges]="true"
            [allowAlignment]="true"
            [maxLength]="255"
            [showContext]="true"
            [alignment]="section().text_title_typography.text_alignment"
            [fontFamily]="section().text_title_typography.font_family"
            [fontSize]="titleFontSize()"
            [fontWeight]="section().text_title_typography.font_weight || theme().section.title_typography.font_weight"
            [textColor]="section().text_title_typography.font_color || theme().section.title_typography.font_color"
            [allowTextColorReset]="!!section().text_title_typography.font_color"
            [darkBackground]="darkBackground()"
            (wysiwygChange)="saveText()"
            (onFontChange)="onTitleFontChange($event)"
            (onFontSizeChange)="onTitleFontSizeChange($event)"
            (onFontWeightChange)="onTitleFontWeightChange($event)"
            (onTextColorChange)="onTitleTextColorChange($event)"
            (onAlignmentChange)="onAlignmentChange($event)"
            [wysiwygHoverIdentifier]="'section-' + section().id"
            (onContextClicked)="openThemeMenu('headings')"
          ></div>
          @if (!textTitle.length) {
            <div class="placeholder">Add a Title</div>
          }
        </div>
      }
      @if (galleryPermissions().can_edit || textParagraph) {
        <div
          class="input-container paragraph {{ paragraphFontSize() }}"
          [appApplyTypographyStyles]="[
            section().text_paragraph_typography,
            theme().section.paragraph_typography,
            tenant()?.default_paragraph_typography,
          ]"
        >
          <div
            class="input"
            [attr.contenteditable]="galleryPermissions().can_edit"
            [allowHtml]="true"
            [allowFontChanges]="true"
            [allowAlignment]="true"
            [(wysiwyg)]="textParagraph"
            [fontFamily]="section().text_paragraph_typography.font_family"
            [defaultFontFamily]="
              theme().section.paragraph_typography.font_family || tenant()?.default_paragraph_typography?.font_family
            "
            [fontSize]="paragraphFontSize()"
            [fontWeight]="
              section().text_paragraph_typography.font_weight || theme().section.paragraph_typography.font_weight
            "
            [alignment]="section().text_paragraph_typography.text_alignment"
            [textColor]="
              section().text_paragraph_typography.font_color || theme().section.paragraph_typography.font_color
            "
            [allowTextColorReset]="!!section().text_paragraph_typography.font_color"
            [maxLength]="4096"
            [showContext]="true"
            (wysiwygChange)="saveText()"
            (onFontChange)="onParagraphFontChange($event)"
            (onTextColorChange)="onParagraphTextColorChange($event)"
            (onFontSizeChange)="onParagraphFontSizeChange($event)"
            (onFontWeightChange)="onParagraphFontWeightChange($event)"
            (onAlignmentChange)="onAlignmentChange($event)"
            [wysiwygHoverIdentifier]="'section-' + section().id"
            (onContextClicked)="openThemeMenu('paragraphs')"
          ></div>
          @if (!textParagraph.length) {
            <div class="placeholder">Add a description</div>
          }
        </div>
      }
    </div>
  </div>
}
